import { render, staticRenderFns } from "./BeforeCreate.vue?vue&type=template&id=42c0b4c2"
import script from "./BeforeCreate.vue?vue&type=script&lang=js"
export * from "./BeforeCreate.vue?vue&type=script&lang=js"
import style0 from "./BeforeCreate.vue?vue&type=style&index=0&id=42c0b4c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports